import {
    LIFE_TIME_VALUE_SUCCESS,
    LIFE_TIME_VALUE_LOADING

} from '../actions/LifeTimeValueAction';

const initialState = {

    amazon: {
        lifeTimeValueData: null,
        isLoading: true,
    },
    shopify: {
        lifeTimeValueData: null,
        isLoading: true,
    },
    wholesale: {
        lifeTimeValueData: null,
        isLoading: true,
    }
};

const LifeTimeValueReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case LIFE_TIME_VALUE_SUCCESS:
            return {
                ...state, [action?.vendor]: { lifeTimeValueData: action.data, isLoading: false }
            };
        case LIFE_TIME_VALUE_LOADING:
            return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default LifeTimeValueReducer;
